import { Section } from '../UI/IgmtInk'

import First from '../../assets/1st-min.jpg'
import FirstWebp from '../../assets/1st.webp'
import Second from '../../assets/2nd-min.jpg'
import SecondWebp from '../../assets/2nd.webp'
import Third from '../../assets/3rd-min.jpg'
import ThirdWebp from '../../assets/3rd.webp'
import Fourth from '../../assets/4rth-min.jpg'
import FourthWebp from '../../assets/4rth.webp'
import Fifth from '../../assets/5th-min.jpg'
import FifthWebp from '../../assets/5th.webp'
import Sixth from '../../assets/6th-min.jpg'
import SixthWebp from '../../assets/6th.webp'
import Seventh from '../../assets/7th-min.jpg'
import SeventhWebp from '../../assets/7th.webp'
import Eighth from '../../assets/8th-min.jpg'
import EighthWebp from '../../assets/8th.webp'
import Nineth from '../../assets/9th-min.jpg'
import NinethWebp from '../../assets/9th.webp'
import Tenth from '../../assets/10th-min.jpg'
import TenthWebp from '../../assets/10th.webp'
import Eleventh from '../../assets/11th-min.jpg'
import EleventhWebp from '../../assets/11th.webp'

const Gallery = props => {
  return (
    <Section
      attr={{ id: 'gallery' }}
      className="p-4 py-9 lg:py-24 bg-[#f9f9f9] animate-slide-down"
    >
      <h2 className="mb-8 md:mb-14 lg:mb-16 text-center font-bold font-['Courgette'] text-blue-500 text-4xl md:text-6xl">
        Our Beloved Son
      </h2>
      <div className="grid grid-auto-fit-sm gap-4 mb-8">
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={FirstWebp} type="image/webp" />
            <source srcSet={First} type="image/jpeg" />

            <img
              className="scale-[1.5] transition-transform mx-auto w-4/5"
              src={FirstWebp}
              alt="1st Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            1ST MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={SecondWebp} type="image/webp" />
            <source srcSet={Second} type="image/jpeg" />

            <img
              className="scale-[1.7] transition-transform mx-auto w-4/5"
              src={SecondWebp}
              alt="2nd Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            2ND MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={ThirdWebp} type="image/webp" />
            <source srcSet={Third} type="image/jpeg" />

            <img
              className="scale-[1.7] transition-transform mx-auto w-4/5"
              src={ThirdWebp}
              alt="3rd Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            3RD MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={FourthWebp} type="image/webp" />
            <source srcSet={Fourth} type="image/jpeg" />

            <img
              className="scale-[1.5] transition-transform mx-auto w-4/5"
              src={FourthWebp}
              alt="4rth Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            4RTH MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={FifthWebp} type="image/webp" />
            <source srcSet={Fifth} type="image/jpeg" />

            <img
              className="scale-[1.6] transition-transform mx-auto w-4/5"
              src={FifthWebp}
              alt="5th Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            5TH MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={SixthWebp} type="image/webp" />
            <source srcSet={Sixth} type="image/jpeg" />

            <img
              className="scale-[1.375] transition-transform mx-auto w-4/5"
              src={SixthWebp}
              alt="6th Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            6TH MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={SeventhWebp} type="image/webp" />
            <source srcSet={Seventh} type="image/jpeg" />

            <img
              className=" transition-transform mx-auto w-4/5"
              src={SeventhWebp}
              alt="7th Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            7TH MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={EighthWebp} type="image/webp" />
            <source srcSet={Eighth} type="image/jpeg" />

            <img
              className="transition-transform mx-auto w-4/5"
              src={EighthWebp}
              alt="8th Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            8TH MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={NinethWebp} type="image/webp" />
            <source srcSet={Nineth} type="image/jpeg" />

            <img
              className="scale-[1.375] transition-transform mx-auto w-4/5"
              src={NinethWebp}
              alt="9th Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            9TH MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={TenthWebp} type="image/webp" />
            <source srcSet={Tenth} type="image/jpeg" />

            <img
              className="transition-transform mx-auto w-4/5"
              src={TenthWebp}
              alt="10th Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            10TH MONTH OF BABY ALI
          </div>
        </div>
        <div className="overflow-hidden rounded-md relative">
          <picture>
            <source srcSet={EleventhWebp} type="image/webp" />
            <source srcSet={Eleventh} type="image/jpeg" />

            <img
              className="scale-[1.25] transition-transform mx-auto w-4/5"
              src={EleventhWebp}
              alt="11th Month of Baby Ali"
            />
          </picture>

          <div className="absolute inset-0 opacity-0 hover:opacity-100 p-4 text-center transition-opacity flex justify-center items-center bg-blue-500/50 font-['Lora'] font-bold text-2xl">
            11TH MONTH OF BABY ALI
          </div>
        </div>
      </div>
      <span className="block mb-8 md:mb-14 lg:mb-16 text-center font-bold font-['Courgette'] text-blue-500 text-2xl md:text-4xl">
        MORE...
      </span>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-5 md:grid-cols-5 sm:grid-cols-4">
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img1 bg-cover h-full"></div>
        </div>
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img2 bg-cover h-full"></div>
        </div>
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img3 bg-cover h-full"></div>
        </div>
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img4 bg-cover h-full"></div>
        </div>
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img5 bg-cover h-full"></div>
        </div>
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img6 bg-cover h-full"></div>
        </div>
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img7 bg-cover h-full"></div>
        </div>
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img8 bg-cover h-full"></div>
        </div>
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img9 bg-cover h-full"></div>
        </div>
        <div className="overflow-hidden h-56 lg:h-72 rounded-md">
          <div className="hover:scale-150 transition-transform bg-img10 bg-cover h-full"></div>
        </div>
      </div>
    </Section>
  )
}

export default Gallery
